<template>
	<div
		class="notice-banner"
		:style="{ backgroundColor: bgColor }"
		role="status"
		:aria-live="closable ? 'polite' : 'assertive'"
	>
		<div class="notice-banner__inner">
			<div class="notice-banner__icon" aria-hidden="true">📢</div>

			<div class="notice-banner__text">
				<slot />
			</div>

			<button
				v-if="closable"
				class="notice-banner__close"
				type="button"
				@click="$emit('close')"
				aria-label="Закрити повідомлення"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<path d="M0.666504 0.666504L7.33317 7.33317" stroke="#64748B" stroke-linecap="round"/>
					<path d="M0.666504 7.33301L7.33317 0.666341" stroke="#64748B" stroke-linecap="round"/>
				</svg>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NoticeBanner',
	props: {
		bgColor: { type: String, default: '#FFF5F5' },
		closable: { type: Boolean, default: false }
	}
}
</script>

<style lang="scss" scoped>
.notice-banner {
	border-radius: 12px;
	margin: 12px 20px 0;
	padding: 14px 16px;
	.notice-banner__inner {
		display: flex;
		align-items: flex-start;
		gap: 12px;
		position: relative;
	}
	.notice-banner__icon {
		font-size: 18px;
		line-height: 1;
		margin-top: 2px;
	}
	.notice-banner__text {
		font-size: 14px;
		line-height: 1.4;
		color: #1E1E1E;
	}
	.notice-banner__close {
		margin-left: auto;
		background: transparent;
		border: 0;
		padding: 6px;
		line-height: 1;
		cursor: pointer;
		border-radius: 8px;
		transition: background-color .15s ease;
	}
	.notice-banner__close:hover { background-color: rgba(43,101,235,.08); }
}

@media (max-width: 992px) {
	.notice-banner { margin: 12px 0 0; }
}
</style>
